import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { DEFAULT_POINTS_PER_STATEMENT, DEFAULT_SCALE_RANGE_FOR_SLIDER } from '../const/const';

// import reducers
import modal from './modal';
import error from './error';
import answers from './answers';
import comments from './comments';
import textAnswers from './textAnswers';
import customTextAnswers from './customTextAnswers';
import animation from './animation';

function createDataReaderReducer(initialState, key) {
  return function reducer(state = initialState, action) {
    if (action.type === 'DATA_RECEIVED') {
      return action.data[key];
    } else {
      return state;
    }
  };
}

const rootReducer = combineReducers({
  modal,
  error,
  answers,
  comments,
  animation,
  textAnswers,
  customTextAnswers,
  customQuestions: createDataReaderReducer({}, 'customQuestions'),
  pages: createDataReaderReducer({}, 'pages'),
  evals: createDataReaderReducer({}, 'evals'),
  statements: createDataReaderReducer({}, 'statements'),
  user: createDataReaderReducer('noUser', 'who'),
  surid: createDataReaderReducer(-1, 'tsn_survey_id'),
  langKeys: createDataReaderReducer({}, 'langKeys'),
  lang: createDataReaderReducer({}, 'lang'),
  customWelcomeText: createDataReaderReducer('', 'welcomeText'),
  customEndText: createDataReaderReducer('', 'endText'),
  judgemental: createDataReaderReducer(false, 'judgemental'),
  enabledSliderLabels: createDataReaderReducer(false, 'enabledSliderLabels'),
  competenciesCommentRequired: createDataReaderReducer(false, 'competenciesCommentRequired'),
  pointsPerStatement: createDataReaderReducer(DEFAULT_POINTS_PER_STATEMENT, 'pointsPerStatement'),
  scaleRange: createDataReaderReducer(DEFAULT_SCALE_RANGE_FOR_SLIDER, 'scaleRange'),
  labels: createDataReaderReducer([], 'labels'),
  indexOfTheLastPage: createDataReaderReducer(1, 'indexOfTheLastPage'),
  routing: routerReducer,
});

export default rootReducer;
